/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface I18nCodeOption
 */
export interface I18nCodeOption {
    /**
     * 
     * @type {number}
     * @memberof I18nCodeOption
     */
    code?: number;
    /**
     * 
     * @type {string}
     * @memberof I18nCodeOption
     */
    name?: string;
}

/**
 * Check if a given object implements the I18nCodeOption interface.
 */
export function instanceOfI18nCodeOption(value: object): value is I18nCodeOption {
    return true;
}

export function I18nCodeOptionFromJSON(json: any): I18nCodeOption {
    return I18nCodeOptionFromJSONTyped(json, false);
}

export function I18nCodeOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): I18nCodeOption {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function I18nCodeOptionToJSON(json: any): I18nCodeOption {
    return I18nCodeOptionToJSONTyped(json, false);
}

export function I18nCodeOptionToJSONTyped(value?: I18nCodeOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
    };
}

